import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  label: {
    font: "600 14px/24px Manrope",
    color: colors.brandBlue500,
  },
  span: {
    font: "500 14px/24px Manrope",
    color: "#465869",
  },
  emptySpan: {
    color: "#9CA6AF",
  },
  valueArrayWrapper: {
    display: "flex",
    alignItems: "flex-start",
    minHeight: "fit-content",
    gap: 8,
    textWrap: "nowrap",
  },
  multipleValuesWrapper: {
    display: "flex",
    alignItems: "flex-start",
    minHeight: "fit-content",
    textWrap: "nowrap",
    flexDirection: "column",
  },
  ellipsis: {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
}));

export default styles;
